export default {
  BusinessPurchaseOrder: {
    header: {
      code: '采购单号',
      supplier: '供应商',
      supplierText: '供应商编码/供应商名称',
      type: '采购类型',
      warehouseCode: '收货仓库',
      status: '采购单状态',
      stockinStatus: '入库状态',
      commodityCode: '商品编码',
      skuCode: 'SKU编码',
      startData: '开始日期',
      endData: '结束日期',
      expectedData: '预计到货时间',
      finishData: '完成日期',
      buyerName: '采购员',
      creationDate: '生成日期'
    },

    purchaseOrderAdd: '新增采购单',
    purchaseOrderExport: '导入采购单',
    modify: '修改',
    review: '审核',
    antiAudit: '反审核',
    purchaseOk: '完成采购',
    finish: '完成',
    cancelPurchase: '取消采购单',
    errorText: '存在状态不正确的单据，无法执行当前操作',
    msgError: '只有待审核单据可以操作编辑',
    msgBox1: '是否',
    msgBox2: '所选单据',

    exportData: {
      export: '导出',
      downName: '采购单导入模板',
      downExport: '采购单导出',
      rule: 'Excel导入采购单规则说明',
      p1: '采购单信息：供应商、采购类型、收货仓库、结算方式，以上信息完全一致则自动合并成一个采购单，如有差异，则自动拆分成不同的采购单。资料中不存在或者禁用的供应商、SKU编码无法导入',
      p2: '导入模板，点击下载',
      title: '采购单导入模板',
      p3: '导入Excel格式必须带标题，红色标题为必填',
      p4: '支持：csv、xls、xlsx格式，一次导入文件大小不能超过128MB，数据行不能超过5万行，如果超过，请分成多次导入。',
    },

    table: {
      code: '采购单号',
      typeMeaning: '采购类型',
      supplierCode: '供应商编码',
      supplierName: '供应商名称',
      warehouseName: '收货仓库',
      statusMeaning: '采购单状态',
      stockinStatusMeaning: '入库状态',
      expectedDate: '预计到货时间',
      paymentType: '结算方式',
      planQty: '采购数量',
      amount: '总金额',
      alreadyQty: '入库数量',
      waitQty: '未入库数量',
      cancelQty: '停止等待数量',
      packagingFlag: '是否含包装',
      shippingFlag: '是否包邮',
      logisticsBusinessName: '物流公司',
      logisticsNo: '运单号',
      logisticsAmount: '运费',
      overfillRate: '溢装比例',
      buyerName: '采购员',
      remark: '备注',
      finishTime: '完成时间',
      auditTime: '审核时间',
      auditName: '审核人',
      sourceCode: '来源单号',
      sourceMeaning: '来源'
    }
  },
  BusinessPurchaseOrder2: {
    code: '入库单号',
    thirdCode: '入库参考号',
    totalItem: '货品总数',
    data: '时间',
    arrivedAt: '到货时间',
    receiveDate: '预计到货时间',
    dropOffMethod: '卸货方式',
    side: '侧面卸货',
    trailer: '拖车卸货',
    externalPo: '入库参考号',
    means: '运输方式',
    Unit: '装运单位',
    container: '柜号/跟踪号',
    detailTitle: '入库单基本信息',
    updateStatus: '更新状态',
    hintMsg: '只能删除状态为New的订单',
    hintMsge: "目前只允许同步状态为 'UploadFail' 和 'New' 的订单",
    timeErrorTip: '日期格式错误',
    FclRdyDate: '集装箱就绪时间',
    FclPickDate: '集装箱完成时间',
    ConEmpDate: '清空集装箱日期',
    ConCollDate: '取回集装箱日期',
    form: {
      thirdCode: '入库参考号',
      vendorId: '供应商',
      vendorName: '供应商名称',
      shippingMethod: '运输方式',
      palletQty: '托盘数量',
      containerId: '集装箱号',
      isTrue: '集装箱号是否正确',
      newContainerId: '新集装箱号',
      containerType: '集装箱类型',
      containerLength: '集装箱尺寸',
      batchCode: '批次号',
      expiryDate: '产品有效期',
      carton: '箱数',
      skuName: '品名',
    },
    detail: {
      poNumber: '入库单号',
      isWrapNo: '确认包装数量',
      wrapQty: '包装数量',
      cartonQty: '纸箱数量',
      palletAvg: '托盘平均高度',
    },
    dialog: {
      arrivedBtn: '已到达',
      verifyBtn: '验证',
      receiveBtn: '接收',
      fclRdyBtn: '集装箱就绪',
      fclPickBtn: '集装箱回收',
      pushBtn: '推送到仓库',
      POId: '入库单标识',
      containerId: '集装箱标识',
      hint: '请确认',
      hint1: '您确定此集装箱',
      hint11: '已准备好提货.',
      hint2: '您确认此订单',
      hint22: '已到达?',
      correctBtn: '正确',
      wrongBtn: '错误',
      inputText: '请选择到达时间',
      arriveDate: '到达时间',
      inputText2: '请输入正确的集装箱标识',
      containerEndTime: '提取时间',
      inputText3: '请选择集装箱提取时间',
      errMsg1: '集装箱号是否正确？',
      errMsg2: '当前状态不可取消',
      errMsg3: '表中必填项不能为空',
      errMsg4: '请先添加商品',
    }
  },

  BusinessPurchaseOrder3: {
    Ps1: '这里的extra labour time不包含SKU Labelling fee & SKU Sorting Fee.',
    PO: '运输方式',
    Container: '集装箱',
    Pallets: '托盘',
    Carton: '纸箱',
    Loose: '散装',
    Pallet: '托盘',
    Not: '未校验',
    pass: '校验通过',
    Fail: '校验失败',
    Type: '集装箱类型',
    Size: '集装箱长度',
    Lift: 'Lift-Off数量',
    Loscom: 'Loscam托盘',
    nonStandard: 'non-standard托盘',
    Putaway: '放置托盘数量',
    Total: '总托盘数量',
    Standard: '客户标准托盘',
    Chep: '客户Chep托盘',
    Hire: '租赁托盘数量',
    cartonQty: '纸箱数量',
    Shrip: '收缩膜包装数量',
    Extra: '额外工时(分钟)',
    comments: '备注',
    PARTIAL: '部分到货',
    FULLY: '全部到货',
    Submit: '提交日期',
    Submitter: '提交人员',
    ps: '总托盘数 必须等于 标准托盘 加 Chep托盘 加 Loscom托盘 加 租赁托盘',
    id: '内部标识',
    Status: '状态',
    warehouseReceiptRemarks: '仓库收货备注',
    Date: '日期',
    Item: '物品计数',
    ContainerId: '集装箱标识',
    PalletQty: '托盘数量',
    Avg: '托盘平均高度',
    Product: '品名',
    Expiry: '到期',
    Qty: '数量',
    ExpectedQty: '预期数量',
    PendingQty: '已到 RECV bin',
    StockedQty: '已上架 D bin',
    FinalQty: '最终实收',
    Batch: '批次',
    Vendor: '供应商 SKU',
    Received: '已收到',
    Received1: '应收',
    Downloadstatus: '下载状态',
    Receiveds: '到货数量',
    IsChecked: '是否已检查',
    IsConfirm: '是否已确认',
    Warehouse: '仓库收货单信息',
    CustomerPalletQty: '客户托盘数量',
  }
};
